import api from "./api";

const route = "/video_props";

const VideoPropsService = {
  getVideoTypes: (video_id) => api.get(`${route}/${video_id}`),
};

export default VideoPropsService;
